import { JobsPageSidePanel } from "@/pages/settings/jobs/JobsPageSidePanel.tsx";
import { Stack } from "@skailer-com/uikit";
import { Outlet } from "react-router-dom";

export function JobsPageLayout() {
  return (
    <Stack className="h-full overflow-hidden" direction="horizontal">
      <JobsPageSidePanel />
      <Outlet />
    </Stack>
  );
}
